import { AreaType, CategoryType, NavigationState } from '../store/navigation.type';

const scheduleCallbackAllowList: [AreaType, CategoryType][] = [
  ['private', 'insurance'],
  ['private', 'others'],
];

const isScheduleCallbackAllowed = (area: AreaType | undefined, category: CategoryType | undefined) =>
  scheduleCallbackAllowList.some((item) => item[0] === area && item[1] === category);

const isScheduledBooking = (navigation: NavigationState) => {
  return (
    isScheduleCallbackAllowed(navigation.area, navigation.category) &&
    navigation.bookingOption === 'selectedTime' &&
    navigation.bookingDate &&
    navigation.bookingTime
  );
};

export { isScheduleCallbackAllowed, isScheduledBooking };
